import { GITLAB_MR_URL_SOURCE } from '@reflex/shared';
import type { PluginWebManifest } from '@reflex/plugin-api/web';

export const gitlabWeb: PluginWebManifest = {
  orgSetupComponent: {
    componentPath: '@reflex/plugin-gitlab/web/GitLabSettingsPage',
    label: 'Connect GitLab so merge request, pipeline, and issue events reach your automations.',
  },
  // `@mr:` category in the launch and chat composers. The server half is the
  // `gitlab-mr` resolver registered in `register()`.
  agentContextProviders: [
    {
      id: 'agent-context-gitlab-mrs',
      kind: 'gitlab-mr',
      label: 'Merge requests',
      keyword: 'mr',
      icon: 'GitPullRequest',
      componentPath: '@reflex/plugin-gitlab/web/GitLabMrContextProvider',
      // Pasting an MR link into the composer is how people actually carry a
      // merge request over from GitLab, so it produces the same `gitlab-mr`
      // chip (and the same `group/project!42` id the resolver expands) that
      // picking one from this menu does. Only the MR itself is described
      // here; the tabs and anchors a link picks up on its way through a
      // browser or a discussion (`/diffs`, `.patch`, `#note_123`) are
      // consumed by the registry, since they all name the same merge request.
      urlPattern: GITLAB_MR_URL_SOURCE,
      urlFlags: 'i',
      urlIdTemplate: '$1!$2',
      mentionBadgeComponentPath: '@reflex/plugin-gitlab/web/GitLabMrMentionBadge',
      order: 15,
    },
  ],
  // A merge-request link is the one URL in agent output that carries a state
  // worth reading at a glance, so it renders as the shared PR chip (icon,
  // number, hover card) instead of a bare link. Ordered ahead of the link
  // unfurler's catch-all (order 100) so the MR badge wins.
  contentScanners: [
    {
      id: 'gitlab:mr-url',
      target: 'url',
      pattern: `^${GITLAB_MR_URL_SOURCE}`,
      flags: 'i',
      componentPath: '@reflex/plugin-gitlab/web/GitLabMrLinkBadge',
      order: 10,
    },
  ],
};
